import Notifications from '@/pages/notifications/Notifications';

import { lazy } from 'react';

// import Produits from "@/pages/produits/Produits";
const Home = lazy(() => import('@/pages/Home/Home'));
const LogErrorsDetail = lazy(() => import('@/pages/logError/LogErrorsDetail'));
// //****Clients*****/
const Clients = lazy(() => import('@/pages/clients/Clients'));
const LinkedClients = lazy(() => import('@/pages/clients/linkedClients/LinkedClients'));
const ClientAddOrUpdate = lazy(() => import('@/pages/clients/ClientAddOrUpdate'));
const ClientReleveDeFactures = lazy(() => import('@/pages/clients/ClientReleveDeFactures/ClientReleveDeFactures'));
const ClientDetails = lazy(() => import('@/pages/clients/ClientDetails/ClientDetails'));
const AvoirFinancierCreate = lazy(
	() => import('@/pages/clients/ClientDetails/avoirFinancier/AvoirFinancierCreation/AvoirFinancierCreate')
);
const AvoirFinancierDetails = lazy(() => import('@/pages/clients/ClientDetails/avoirFinancier/AvoirFinancierDetails'));
// //****Contacts *****/
const Contacts = lazy(() => import('@/pages/contacts/Contacts'));
const ContactCreation = lazy(() => import('@/pages/contacts/ContactCreation'));
const ContactDetails = lazy(() => import('@/pages/contacts/ContactDetails'));
const Cars = lazy(() => import('@/pages/cars/Cars'));
const CarDetails = lazy(() => import('@/pages/cars/CarDetails'));
const CarCreation = lazy(() => import('@/pages/cars/CarCreation'));
// //****Produits *****/
const Produits = lazy(() => import('@/pages/produits/Produits'));
const ProduitsDetails = lazy(() => import('@/pages/produits/ProduitsDetails'));
const SuggererProduit = lazy(() => import('@/pages/produits/SuggestedProducts/SuggererProduit'));
const SuggestionsList = lazy(() => import('@/pages/produits/SuggestedProducts/SuggestionsList'));
const SeggestedDetails = lazy(() => import('@/pages/produits/SuggestedProducts/SuggestedDetails'));
const ProductsMapped = lazy(() => import('@/pages/produits/HistoryOfMappingProducts/HistoryOfMappingProducts'));
const ProductMappedDetails = lazy(() => import('@/pages/produits/ProductMappedDetails'));
const EditProduct = lazy(() => import('@/pages/produits/EditProduct'));
// //****Quotas *****/
const Quotas = lazy(() => import('@/pages/Quotas/Quotas'));
// //****Suppliers *****/
const Suppliers = lazy(() => import('@/pages/Suppliers/Suppliers'));
const SuppSuggHistory = lazy(() => import('@/pages/Suppliers/SuppSuggHistory'));
const SuggestSupplier = lazy(() => import('@/pages/Suppliers/SuggestSupplier'));
const SupplierDetails = lazy(() => import('@/pages/Suppliers/SupplierDetails'));
const EditSupplier = lazy(() => import('@/pages/Suppliers/EditSupplier'));
const AddSuppPayment = lazy(() => import('@/pages/Suppliers/AddSuppPayment'));
// //****Achats offers*****/
const OffersOrders = lazy(() => import('@/pages/achats/offersOrders/OffersOrders'));
const OffersOrdersDetails = lazy(() => import('@/pages/achats/offersOrders/OffersOrdersDetails'));
// //****Propositions *****/
const OrderProposes = lazy(() => import('@/pages/achats/orderProposes/OrderProposes'));
const OrderProposeDetails = lazy(() => import('@/pages/achats/orderProposes/OrderProposeDetails'));
const OrderProposesCreation = lazy(
	() => import('@/pages/achats/orderProposes/PropositionOrderForm/OrderProposesCreation')
);
// //****demande prix *****/
const PriceRequests = lazy(() => import('@/pages/achats/priceRequests/PriceRequests'));
const PriceRequestsDetails = lazy(() => import('@/pages/achats/priceRequests/PriceRequestsDetails'));
const PriceRequestsCreation = lazy(() => import('@/pages/achats/priceRequests/PriceRequestsCreation'));
// //****Receptions *****/
const Receptions = lazy(() => import('@/pages/achats/receptions/Receptions'));
const ReceptionDetails = lazy(() => import('@/pages/achats/receptions/ReceptionDetails'));
const ReceptionCreation = lazy(() => import('@/pages/achats/receptions/receptionCreation/ReceptionCreation'));
// //****Supp orders *****/
const SupplierOrders = lazy(() => import('@/pages/achats/supplierOrders/SupplierOrders'));
const SupplierOrderDetails = lazy(() => import('@/pages/achats/supplierOrders/details/SupplierOrderDetails'));
const SuppOrderCreation = lazy(() => import('@/pages/achats/supplierOrders/SuppOrderCreation'));
// //****Invoices *****/
const SupplierInvoices = lazy(() => import('@/pages/achats/supplierInvoices/SupplierInvoices'));
const SuppInvoiceDetails = lazy(() => import('@/pages/achats/supplierInvoices/suppInvoiceDetails/SuppInvoiceDetails'));
const SuppInvoiceCreation = lazy(
	() => import('@/pages/achats/supplierInvoices/suppInvoiceCreation/SuppInvoiceCreation')
);
const AddPayment = lazy(() => import('@/pages/achats/supplierInvoices/AddPayment'));
// //****Emis *****/
const AvoirsEmis = lazy(() => import('@/pages/achats/avoirEmis/AvoirsEmis'));
const AvoirEmisCreation = lazy(() => import('@/pages/achats/avoirEmis/AvoirEmisCreation/AvoirEmisCreation'));
const AvoirEmisDetails = lazy(() => import('@/pages/achats/avoirEmis/AvoirEmisDetails'));
// //****Recus *****/
const AvoirsRecus = lazy(() => import('@/pages/achats/avoirRecus/AvoirsRecus'));
const AvoirRecusCreation = lazy(() => import('@/pages/achats/avoirRecus/avoirRecusCreation/AvoirRecusCreation'));
const AvoirRecusDetails = lazy(() => import('@/pages/achats/avoirRecus/AvoirRecusDetails'));
// //****Expenses*****/
const Expenses = lazy(() => import('@/pages/achats/expenses/Expenses'));
const ExpensesAdd = lazy(() => import('@/pages/achats/expenses/ExpensesAdd'));
const ExpensesDetails = lazy(() => import('@/pages/achats/expenses/ExpensesDetails'));
// //****Vouchers *****/
const ReleasedVouchers = lazy(() => import('@/pages/achats/releasedVouchers/ReleasedVouchers'));
const ReleasedVouchersCreation = lazy(() => import('@/pages/achats/releasedVouchers/ReleasedVouchersCreation'));
const ReleasedVouchersDetails = lazy(() => import('@/pages/achats/releasedVouchers/ReleasedVouchersDetails'));
// // Offers
const Offers = lazy(() => import('@/pages/ventes/Offers/Offers'));
const ArchivedOffers = lazy(() => import('@/pages/ventes/Offers/ArchivedOffers'));
const OfferDetails = lazy(() => import('@/pages/ventes/Offers/offerDetails/OfferDetails'));
const OfferCreation = lazy(() => import('@/pages/ventes/Offers/offerAdd/OfferCreation'));
const OffersView = lazy(() => import('@/pages/ventes/Offers/OffersView'));
const DiscountsUpdate = lazy(() => import('@/pages/settings/discounts/discountsByCategory/DiscountsUpdate'));
// Demands
const Requests = lazy(() => import('@/pages/Requests/Requests'));
const RequestDetails = lazy(() => import('@/pages/Requests/RequestDetails/RequestDetails'));
const RequestAddOrUpdate = lazy(() => import('@/pages/Requests/RequestAddOrUpdate/RequestAddOrUpdate'));
// Loyalty programes
const LoyaltyPrograms = lazy(() => import('@/pages/loyaltyPrograms/LoyaltyPrograms'));
const LoyaltyProgramsDetails = lazy(() => import('@/pages/loyaltyPrograms/details/LoyaltyProgramsDetails'));
const LoyaltyProgramsCreation = lazy(
	() => import('@/pages/loyaltyPrograms/loyaltyProgramsCreation/LoyaltyProgramsCreation')
);
// //****Reports*****/
const Rapport = lazy(() => import('@/pages/rapports/Rapports'));
const MarketplaceReport = lazy(() => import('@/pages/rapports/marketplaceReport/MarketplaceReport'));
const Ventes = lazy(() => import('@/pages/rapports/ventesReports/ventes/Ventes'));
const ReeditedBLs = lazy(() => import('@/pages/rapports/ventesReports/reeditedBLs/ReeditedBLs'));
const OutOfStockSales = lazy(() => import('@/pages/rapports/ventesReports/outOfStock/OutOfStockSales'));
const ProductsTable = lazy(() => import('@/pages/rapports/ventesReports/productsTable/ProductsTable'));
const PaymentsReport = lazy(() => import('@/pages/rapports/ventesReports/paymentsReport/PaymentsReport'));
const CashRegister = lazy(() => import('@/pages/rapports/ventesReports/cashRegister/CashRegister'));
const Achat = lazy(() => import('@/pages/rapports/Purchases/Purchases'));
const Client = lazy(() => import('@/pages/rapports/client/Client'));
const ClientPayments = lazy(() => import('@/pages/rapports/clientPayments/ClientPayments'));
const Produit = lazy(() => import('@/pages/rapports/productReports/produit/Produit'));
const ProductMouvements = lazy(() => import('@/pages/rapports/productReports/productMouvements/ProductMouvements'));
const MissingProducts = lazy(() => import('@/pages/rapports/productReports/missingProducts/MissingProducts'));
const QuotedProducts = lazy(() => import('@/pages/rapports/productReports/quotedProducts/QuotedProducts'));
const StockReport = lazy(() => import('@/pages/rapports/stockReports/StockReport'));
const ChiffreAffaires = lazy(() => import('@/pages/rapports/onlineOrdersReports/turnover/Turnover'));
const ChiffreAffairesClient = lazy(() => import('@/pages/rapports/onlineOrdersReports/turnoverClient/TurnoverClient'));
const RapportSurProduit = lazy(
	() => import('@/pages/rapports/onlineOrdersReports/orderOnlineProduct/OrderOnlineProduct')
);
const LogErrors = lazy(() => import('@/pages/rapports/onlineOrdersReports/logErrors/LogErrors'));
const PertesEtManque = lazy(() => import('@/pages/rapports/onlineOrdersReports/pertesEtManque/PertesEtManque'));
const Exchanges = lazy(() => import('@/pages/rapports/exchange/ExchangeReport'));
const BillingReport = lazy(() => import('@/pages/rapports/ventesReports/billingReport/BillingReport'));
const AvoirsReport = lazy(() => import('@/pages/rapports/ventesReports/avoirsReport/AvoirsReport'));
const OperationalExcellence = lazy(() => import('@/pages/rapports/performance/PerformanceOperational'));
const SellOutReport = lazy(() => import('@/pages/rapports/sellOutReport/SellOutReport'));
const ShortageReport = lazy(() => import('@/pages/rapports/shortageReport/ShortageReport'));
const PublicationsReport = lazy(() => import('@/pages/rapports/publicationsReport/PublicationsReport'));
// //****Stock*****/
const Stock = lazy(() => import('@/pages/stock/Stock'));
const StockImportsHistory = lazy(() => import('@/pages/stock/stockImports/StockImportsHistory'));
const StockImport = lazy(() => import('@/pages/stock/stockImports/StockImport'));
const StockImportDetails = lazy(() => import('@/pages/stock/stockImports/StockImportDetails'));
// //****Inventaires****/
const Inventaires = lazy(() => import('@/pages/inventaires/Inventaires'));
const InventaireAddOrUpdate = lazy(() => import('@/pages/inventaires/InventaireAddOrUpdate/InventaireAddOrUpdate'));
const InventaireDetails = lazy(() => import('@/pages/inventaires/InventaireDetails'));
const TransfertsEntrepot = lazy(() => import('@/pages/transferts-entrepot/TransfertsEntrepot'));
const TransfertsEntrepotDetails = lazy(() => import('@/pages/transferts-entrepot/TransfertsEntrepotDetails'));
const TransfertCreation = lazy(() => import('@/pages/transferts-entrepot/transfertCreation/TransfertCreation'));
const DormantProducts = lazy(() => import('@/pages/rapports/productReports/dormantProducts/DormantProducts'));
// Commande client
const CommandesClients = lazy(() => import('@/pages/ventes/CommandesClients/CommandesClients'));
const ScanProducts = lazy(() => import('@/pages/ventes/CommandesClients/barcodeScan/ScanProducts'));
const ScanProductLB = lazy(() => import('@/pages/ventes/BonDeLivraison/barcodeScan/ScanProducts'));
const ClientOrdersCreation = lazy(
	() => import('@/pages/ventes/CommandesClients/ClientOrdersCreation/ClientOrdersCreation')
);
const CommandesClientsDetails = lazy(() => import('@/pages/ventes/CommandesClients/details/CommandesClientsDetails'));
// Bon de livraison
const BonDeLivraison = lazy(() => import('@/pages/ventes/BonDeLivraison/BonDeLivraison'));
const ShippingTable = lazy(() => import('@/pages/ventes/BonDeLivraison/ShippingTable'));
const ClientDeliveryNotesCreation = lazy(
	() => import('@/pages/ventes/BonDeLivraison/clientDeliveryNotesCreation/ClientDeliveryNotesCreation')
);
const BonDeLivraisonDetails = lazy(() => import('@/pages/ventes/BonDeLivraison/details/BonDeLivraisonDetails'));
// Factures
const Factures = lazy(() => import('@/pages/ventes/Factures/Factures'));
const GenerateClientInvoice = lazy(() => import('@/pages/ventes/Factures/generateClientInvoice/GenerateClientInvoice'));
const GenerateInvoicePDFs = lazy(() => import('@/pages/ventes/Factures/generateInvoicePDFs/GenerateInvoicePDFs'));
const ClientInvoiceForm = lazy(() => import('@/pages/ventes/Factures/ClientInvoiceForm/ClientInvoiceForm'));
const FacturesDetails = lazy(() => import('@/pages/ventes/Factures/details/FacturesDetails'));
const InvoiceDiscountPdf = lazy(() => import('@/pages/ventes/Factures/InvoiceDiscountPdf'));
// Payments
const Payments = lazy(() => import('@/pages/ventes/payments/Payments'));
const PaymentsDetails = lazy(() => import('@/pages/ventes/payments/PaymentsDetails'));
const PaymentsCreation = lazy(() => import('@/pages/ventes/payments/payment-creation/PaymentsCreation'));
// bordereaux
const Bordereaux = lazy(() => import('@/pages/ventes/bordereaux/Bordereaux'));
const BordereauxDetails = lazy(() => import('@/pages/ventes/bordereaux/details/BordereauxDetails'));
const BordereauxPDF = lazy(() => import('@/pages/ventes/bordereaux/details/PDFGenerator2'));
const BordereauxCreation = lazy(() => import('@/pages/ventes/bordereaux/bordereauxCreation/BordereauxCreation'));
const DeliveryValidation = lazy(() => import('@/pages/ventes/bordereaux/DeliveryValidation'));
const GroupedPayments = lazy(() => import('@/pages/ventes/bordereaux/details/GroupedPayments'));
// bordereaux Check
const BordereauxCheck = lazy(() => import('@/pages/ventes/bordereauxCheck/BordereauxCheck'));
const BordereauxCheckDetails = lazy(() => import('@/pages/ventes/bordereauxCheck/details/BordereauxCheckDetails'));
const BordereauxCheckCreation = lazy(
	() => import('@/pages/ventes/bordereauxCheck/bordereauxCheckCreation/BordereauxCheckCreation')
);
// avoir client
const AvoirsClient = lazy(() => import('@/pages/ventes/AvoirsClient/AvoirsClient'));
const AvoirsClientAddOrUpdate = lazy(
	() => import('@/pages/ventes/AvoirsClient/AvoirsClientAddOrUpdate/AvoirsClientAddOrUpdate')
);
const AvoirsClientDetails = lazy(() => import('@/pages/ventes/AvoirsClient/AvoirsClientDetails'));
// //****Quotation****/
const Quotation = lazy(() => import('@/pages/ventes/Quotation/Quotation'));
const QuotationCreation = lazy(() => import('@/pages/ventes/Quotation/QuotationCreation'));
const QuotationDetails = lazy(() => import('@/pages/ventes/Quotation/QuotationDetails/QuotationDetails'));
// Colleagues
const Colleagues = lazy(() => import('@/pages/exchanges/colleagues/Colleagues'));
const ColleaguesDetails = lazy(() => import('@/pages/exchanges/colleagues/colleagueDetails/ColleagueDetails'));
const ColleaguesCreation = lazy(() => import('@/pages/exchanges/colleagues/ColleaguesFrom'));
const ColleaguesPurchases = lazy(() => import('@/pages/exchanges/colleaguesPurchase/CollearguesPurchase'));
const ColleaguesPurchasesDetails = lazy(() => import('@/pages/exchanges/colleaguesPurchase/ColleaguesPurchageDetails'));
const ColleaguesPurchaseCreation = lazy(
	() => import('@/pages/exchanges/colleaguesPurchase/colleaguesPurchaseCreation/ColleaguesPurchaseCreation')
);
const ColleaguesSales = lazy(() => import('@/pages/exchanges/colleaguesSales/ColleaguesSales'));
const ColleaguesSalesDetails = lazy(() => import('@/pages/exchanges/colleaguesSales/ColleaguesSalesDetails'));
const ColleaguesSalesCreation = lazy(
	() => import('@/pages/exchanges/colleaguesSales/colleaguesSalesCreation/ColleaguesSalesCreation')
);
const ColleaguesReceiptCreation = lazy(
	() => import('@/pages/exchanges/colleaguesCashManagment/ColleaguesReceipt/ColleaguesReceiptCreation')
);
const ColleaguesReceiptDetails = lazy(
	() => import('@/pages/exchanges/colleaguesCashManagment/ColleaguesReceipt/ColleaguesReceiptDetails')
);
const ColleaguesOutflowCreation = lazy(
	() => import('@/pages/exchanges/colleaguesCashManagment/ColleaguesOutflow/ColleaguesOutflowCreation')
);
const ColleaguesOutflowDetails = lazy(
	() => import('@/pages/exchanges/colleaguesCashManagment/ColleaguesOutflow/ColleaguesOutflowDetails')
);
// //****Settings****/
const Settings = lazy(() => import('@/pages/settings/Settings'));
// //****Publications****/
const PublicationCreation = lazy(() => import('@/pages/publications/PublicationCreation'));
const Publications = lazy(() => import('@/pages/publications/Publications'));
const ArchivedPublications = lazy(() => import('@/pages/publications/ArchivedPublications'));
const PublicationDetails = lazy(() => import('@/pages/publications/PublicationDetails'));
const LaboSpaceDetails = lazy(() => import('@/pages/laboSpace/LaboSpaceDetails'));
const LaboProducts = lazy(() => import('@/pages/laboSpace/LaboProducts'));
const LaboEvents = lazy(() => import('@/pages/laboSpace/LaboEvents'));
const LaboEducationalHub = lazy(() => import('@/pages/laboSpace/LaboEducationalHub'));
const EspaceEvents = lazy(() => import('@/pages/espaceEvents/EspaceEvents'));
const EspaceEventsArchived = lazy(() => import('@/pages/espaceEvents/EspaceEventsArchived'));
const EspaceEventsCreate = lazy(() => import('@/pages/espaceEvents/EspaceEventsCreate'));
const EspaceEventsDetails = lazy(() => import('@/pages/espaceEvents/EspaceEventsDetails'));

export const NavPaths = [
	//  {/* notifications */}
	{
		path: '/notifications',
		Component: Notifications,
	},
	//  {/* TableauDeBord */}
	{
		path: '/',
		Component: Home,
	},
	{
		path: '/home',
		Component: Home,
	},
	// //   {/* clients */}
	{
		path: '/clients',
		Component: Clients,
		canDoes: ['get_clients'],
	},
	{
		path: '/clients/creation',
		Component: ClientAddOrUpdate,
		canDoes: ['add_client', 'get_accepted_payment_methods'],
	},
	{
		path: '/clients/creation/:id',
		Component: ClientAddOrUpdate,
		canDoes: ['edit_client_info', 'get_accepted_payment_methods', 'get_single_client'],
	},
	{
		path: '/clients/details/:id',
		Component: ClientDetails,
		canDoes: ['get_single_client'],
	},
	{
		path: '/clients/linked',
		Component: LinkedClients,
		canDoes: ['get_clients'],
	},
	{
		path: '/clients/details/:id/financial',
		Component: AvoirFinancierCreate,
		canDoes: ['get_single_client', 'add_client_financial_return'],
	},
	{
		path: '/clients/details/:id/financial/:finId',
		Component: AvoirFinancierDetails,
		canDoes: ['get_single_client', 'get_client_financial_returns'],
	},
	{
		path: '/clients/details/:id/releve-de-factures',
		Component: ClientReleveDeFactures,
		canDoes: ['get_all_client_invoices'],
	},
	// {/* contacts */}
	{
		path: '/contacts',
		Component: Contacts,
		canDoes: ['get_contacts'],
	},
	{
		path: '/contacts/creation-de-contact',
		Component: ContactCreation,
		canDoes: ['add_contact'],
	},
	{
		path: '/contacts/creation-de-contact/:id',
		Component: ContactCreation,
		canDoes: ['edit_contact', 'get_contact_by_id'],
	},
	{
		path: '/contacts/:id',
		Component: ContactDetails,
		canDoes: ['get_contact_by_id'],
	},
	// {/* suppliers */}
	{
		path: '/fournisseurs',
		Component: Suppliers,
		canDoes: ['get_suppliers'],
		premium: true,
	},
	{
		path: '/fournisseurs/historique',
		Component: SuppSuggHistory,
		canDoes: ['get_all_supplier_suggestion'],
		premium: true,
	},
	{
		path: '/fournisseurs/suggerer-fournisseur',
		Component: SuggestSupplier,
		canDoes: ['add_supplier_suggestion'],
		premium: true,
	},
	{
		path: '/fournisseurs/suggerer-fournisseur/:id',
		Component: EditSupplier,
		canDoes: ['add_supplier_suggestion'],
		premium: true,
	},
	{
		path: '/fournisseurs/details/:id',
		Component: SupplierDetails,
		canDoes: ['get_supplier_by_id'],
		premium: true,
	},
	{
		path: '/fournisseurs/modifier/:id',
		Component: EditSupplier,
		canDoes: ['add_supplier_info'],
		premium: true,
	},
	{
		path: '/fournisseurs/details/:id/ajouter-paiement',
		Component: AddSuppPayment,
		canDoes: ['add_supplier_payment'],
		premium: true,
	},
	// {/* products */}
	{
		path: '/produits',
		Component: Produits,
		canDoes: ['get_sobrus_products'],
	},
	{
		path: '/produits/modifier-produit/:id',
		Component: EditProduct,
		canDoes: ['add_product_data'],
	},
	{
		path: '/produits/list-des-mapping',
		Component: ProductsMapped,
		canDoes: ['mapping_history_products'],
	},
	{
		path: '/produits/list-des-mapping/:id',
		Component: ProductMappedDetails,
		canDoes: ['no_mapping_products'],
	},
	{
		path: '/produits/list-des-suggestions',
		Component: SuggestionsList,
		canDoes: ['get_all_suggestions'],
	},
	{
		path: '/produits/list-des-suggestions/:id',
		Component: SeggestedDetails,
		canDoes: ['get_all_suggestions'],
	},
	{
		path: '/produits/details/:id',
		Component: ProduitsDetails,
		canDoes: ['get_single_product'],
	},
	{
		path: '/produits/suggerer-produit',
		Component: SuggererProduit,
		canDoes: ['add_suggestion'],
	},
	{
		path: '/produits/suggerer-produit/:id',
		Component: SuggererProduit,
		canDoes: ['add_suggestion'],
	},
	// Quotas
	{
		path: '/quotas',
		Component: Quotas,
		canDoes: ['get_client_sales_quotas'],
	},
	// {/* Achats */}
	//  {/* ---Order propose*/}
	{
		path: '/achats/marketplace-commande',
		Component: OffersOrders,
		canDoes: ['get_marketplace_orders_list'],
		premium: true,
	},
	{
		path: '/achats/marketplace-commande/details/:id',
		Component: OffersOrdersDetails,
		canDoes: ['get_marketplace_order_by_id'],
		premium: true,
	},
	{
		path: '/achats/proposition-commande',
		Component: OrderProposes,
		canDoes: ['get_all_supplier_purchase_suggestion'],
		premium: true,
	},
	{
		path: '/achats/proposition-commande/details/:id',
		Component: OrderProposeDetails,
		canDoes: ['get_single_supplier_purchase_suggestion'],
		premium: true,
	},
	{
		path: '/achats/proposition-commande/creation',
		Component: OrderProposesCreation,
		canDoes: ['add_supplier_purchase_suggestion'],
		premium: true,
	},
	{
		path: '/achats/proposition-commande/creation/:id',
		Component: OrderProposesCreation,
		canDoes: [
			'get_single_supplier_purchase_suggestion',
			'edit_supplier_purchase_suggestions',
			'add_supplier_purchase_suggestion',
		],
		premium: true,
	},
	//  {/* ---Demande prix*/}
	{
		path: '/achats/demande-prix',
		Component: PriceRequests,
		canDoes: ['get_supplier_price_request_list'],
		premium: true,
	},
	{
		path: '/achats/demande-prix/details/:id',
		Component: PriceRequestsDetails,
		canDoes: ['get_single_supplier_price_request'],
		premium: true,
	},
	{
		path: '/achats/demande-prix/creation',
		Component: PriceRequestsCreation,
		canDoes: ['add_supplier_price_request'],
		premium: true,
	},
	{
		path: '/achats/demande-prix/creation/:id',
		Component: PriceRequestsCreation,
		canDoes: ['get_single_supplier_price_request', 'update_supplier_price_request'],
		premium: true,
	},
	// {/* ---supplier orders */}
	{
		path: '/achats/bons-de-commande',
		Component: SupplierOrders,
		canDoes: ['get_supplier_purchase_order'],
		premium: true,
	},
	{
		path: '/achats/bons-de-commande/details/:id',
		Component: SupplierOrderDetails,
		canDoes: ['get_single_supplier_purchase_order'],
		premium: true,
	},
	{
		path: '/achats/bons-de-commande/creation',
		Component: SuppOrderCreation,
		canDoes: ['add_supplier_purchase_order'],
		premium: true,
	},
	{
		path: '/achats/bons-de-commande/creation/:id',
		Component: SuppOrderCreation,
		canDoes: ['get_single_supplier_purchase_order', 'edit_supplier_purchase_order'],
		premium: true,
	},
	// {/* ---Receptions */}
	{
		path: '/achats/bons-de-reception',
		Component: Receptions,
		canDoes: ['get_all_supplierdeliverynotes'],
		premium: true,
	},
	{
		path: '/achats/bons-de-reception/details/:id',
		Component: ReceptionDetails,
		canDoes: ['get_single_supplierdeliverynote', 'update_supplierdeliverynote_status', 'edit_supplierdeliverynote'],
		premium: true,
	},
	{
		path: '/achats/bons-de-reception/creation',
		Component: ReceptionCreation,
		canDoes: ['get_all_supplierdeliverynotes', 'add_supplier_delivery_note'],
		premium: true,
	},
	{
		path: '/achats/bons-de-reception/creation/:id',
		Component: ReceptionCreation,
		canDoes: ['edit_supplierdeliverynote'],
		premium: true,
	},
	//  {/* ---supplier invoices */}
	{
		path: '/achats/factures-fournisseur',
		Component: SupplierInvoices,
		canDoes: ['get_supplier_invoice'],
		premium: true,
	},
	{
		path: '/achats/factures-fournisseur/details/:id',
		Component: SuppInvoiceDetails,
		canDoes: ['get_single_supplier_invoice'],
		premium: true,
	},
	{
		path: '/achats/factures-fournisseur/creation',
		Component: SuppInvoiceCreation,
		canDoes: ['add_supplier_invoice'],
		premium: true,
	},
	{
		path: '/achats/factures-fournisseur/creation/:id',
		Component: SuppInvoiceCreation,
		canDoes: ['edit_supplier_invoice'],
		premium: true,
	},
	{
		path: '/achats/factures-fournisseur/ajouter-paiement/:id',
		Component: AddPayment,
		canDoes: ['add_supplier_payment'],
		premium: true,
	},
	//  {/* ---supplier avoir emis */}
	{
		path: '/achats/avoir-emis',
		Component: AvoirsEmis,
		canDoes: ['get_all_supplier_issued_return'],
		premium: true,
	},
	{
		path: '/achats/avoir-emis/details/:id',
		Component: AvoirEmisDetails,
		canDoes: ['get_single_supplier_issued_return'],
		premium: true,
	},
	{
		path: '/achats/avoir-emis/creation',
		Component: AvoirEmisCreation,
		canDoes: ['add_supplier_issued_return'],
		premium: true,
	},
	{
		path: '/achats/avoir-emis/creation/:id',
		Component: AvoirEmisCreation,
		canDoes: ['edit_supplier_issued_return'],
		premium: true,
	},
	//  {/* ---supplier avoir reçu */}
	{
		path: '/achats/avoir-recu',
		Component: AvoirsRecus,
		canDoes: ['get_all_supplier_received_return'],
		premium: true,
	},
	{
		path: '/achats/avoir-recu/details/:id',
		Component: AvoirRecusDetails,
		canDoes: ['get_single_supplier_received_return'],
		premium: true,
	},
	{
		path: '/achats/avoir-recu/creation',
		Component: AvoirRecusCreation,
		canDoes: ['add_supplier_received_return'],
		premium: true,
	},
	{
		path: '/achats/avoir-recu/creation/:id',
		Component: AvoirRecusCreation,
		canDoes: ['edit_supplier_received_returns'],
		premium: true,
	},
	//  {/* ---supplier voucher release */}
	{
		path: '/achats/bons-de-sortie',
		Component: ReleasedVouchers,
		canDoes: ['get_release_voucher'],
		premium: true,
	},
	{
		path: '/achats/bons-de-sortie/details/:id',
		Component: ReleasedVouchersDetails,
		canDoes: ['get_single_release_voucher'],
		premium: true,
	},
	{
		path: '/achats/bons-de-sortie/creation',
		Component: ReleasedVouchersCreation,
		canDoes: ['add_release_voucher'],
		premium: true,
	},
	{
		path: '/achats/bons-de-sortie/creation/:id',
		Component: ReleasedVouchersCreation,
		canDoes: ['edit_release_voucher'],
		premium: true,
	},
	//  {/* ---Expenses */}
	{
		path: '/achats/expenses',
		Component: Expenses,
		canDoes: [''],
		premium: true,
	},
	{
		path: '/achats/expenses/details/:id',
		Component: ExpensesDetails,
		canDoes: [''],
		premium: true,
	},
	{
		path: '/achats/expenses/creation',
		Component: ExpensesAdd,
		canDoes: [''],
		premium: true,
	},
	{
		path: '/achats/expenses/creation/:id',
		Component: ExpensesAdd,
		canDoes: [''],
		premium: true,
	},
	// {/* Ventes -> Offers */}
	{
		path: '/ventes/offers',
		Component: Offers,
		canDoes: ['get_offers_list'],
		premium: false,
	},
	{
		path: '/ventes/offers/archived',
		Component: ArchivedOffers,
		canDoes: ['get_offers_list'],
		premium: false,
	},
	{
		path: '/ventes/offers/marketplace',
		Component: OffersView,
		canDoes: ['get_offers_list'],
		premium: false,
	},
	{
		path: '/ventes/offers/details/:id',
		Component: OfferDetails,
		canDoes: ['get_offer_by_id'],
		premium: false,
	},
	{
		path: '/ventes/offers/create',
		Component: OfferCreation,
		canDoes: ['add_offer'],
		premium: false,
	},
	{
		path: '/ventes/offers/create/:id',
		Component: OfferCreation,
		canDoes: ['update_offer'],
		premium: false,
	},
	// {/* ---clients orders */}
	{
		path: '/ventes/commandes-clients',
		Component: CommandesClients,
		canDoes: ['get_client_orders'],
	},
	{
		path: '/ventes/commandes-clients/scan',
		Component: ScanProducts,
		canDoes: ['get_client_orders'],
	},
	{
		path: '/ventes/commandes-clients/details/:id',
		Component: CommandesClientsDetails,
		canDoes: ['get_client_order_by_id'],
	},
	{
		path: '/ventes/commandes-clients/creation',
		Component: ClientOrdersCreation,
		canDoes: ['add_client_orders'],
	},
	{
		path: '/ventes/commandes-clients/creation/:id',
		Component: ClientOrdersCreation,
		canDoes: ['get_client_order_by_id', 'edit_client_order_by_id'],
	},
	// {/* ---bon de livraison orders */}
	{
		path: '/ventes/bon-de-livraison',
		Component: BonDeLivraison,
		canDoes: ['get_all_client_delivery_notes'],
		premium: true,
	},
	{
		path: '/ventes/bon-de-livraison/expedition',
		Component: ShippingTable,
		canDoes: ['get_all_client_delivery_notes'],
		premium: true,
	},
	{
		path: '/ventes/bon-de-livraison/scan',
		Component: ScanProductLB,
		canDoes: ['get_all_client_delivery_notes'],
	},
	{
		path: '/ventes/bon-de-livraison/details/:id',
		Component: BonDeLivraisonDetails,
		canDoes: ['get_client_delivery_notes_by_id'],
		premium: true,
	},
	{
		path: '/ventes/bon-de-livraison/creation',
		Component: ClientDeliveryNotesCreation,
		canDoes: ['post_client_delivery_note', 'get_client_orders'],
		premium: true,
	},
	{
		path: '/ventes/bon-de-livraison/creation/:id',
		Component: ClientDeliveryNotesCreation,
		canDoes: ['edit_client_delivery_notes', 'get_client_orders', 'get_client_delivery_notes_by_id'],
		premium: true,
	},
	// {/* ---Factures */}
	{
		path: '/ventes/facture-client',
		Component: Factures,
		canDoes: ['get_all_client_invoices'],
		premium: true,
	},
	{
		path: '/ventes/facture-client/generate',
		Component: GenerateClientInvoice,
		canDoes: [''],
		premium: true,
	},
	{
		path: '/ventes/facture-client/generate-pdfs',
		Component: GenerateInvoicePDFs,
		canDoes: [''],
		premium: true,
	},
	{
		path: '/ventes/facture-client/details/:id',
		Component: FacturesDetails,
		canDoes: ['get_client_invoice_by_id'],
		premium: true,
	},
	{
		path: '/ventes/facture-client/details/:id/discount-print',
		Component: InvoiceDiscountPdf,
		canDoes: ['get_client_invoice_by_id'],
		premium: true,
	},
	{
		path: '/ventes/facture-client/creation',
		Component: ClientInvoiceForm,
		canDoes: ['add_client_invoice', 'get_all_client_delivery_notes'],
		premium: true,
	},
	{
		path: '/ventes/facture-client/creation/:id',
		Component: ClientInvoiceForm,
		canDoes: ['get_client_invoice_by_id', 'edit_client_invoice', 'get_all_client_delivery_notes'],
		premium: true,
	},
	// {/* ---Payments */}
	{
		path: '/ventes/payments',
		Component: Payments,
		canDoes: ['get_all_client_payments'],
		premium: true,
	},
	{
		path: '/ventes/payments/details/:id',
		Component: PaymentsDetails,
		canDoes: ['get_single_client_payments'],
		premium: true,
	},
	{
		path: '/ventes/payments/creation',
		Component: PaymentsCreation,
		canDoes: ['add_client_payments'],
		premium: true,
	},
	{
		path: '/ventes/payments/creation/:id',
		Component: PaymentsCreation,
		canDoes: ['add_client_payments'],
		premium: true,
	},
	// {/* ---Bordereaux d'expédition */}
	{
		path: '/ventes/bordereaux',
		Component: Bordereaux,
		canDoes: ['get_client_dispatch_notes_list'],
		premium: true,
	},
	{
		path: '/ventes/bordereaux/details/:id',
		Component: BordereauxDetails,
		canDoes: ['get_client_dispatch_note_by_id'],
		premium: true,
	},
	{
		path: '/ventes/bordereaux/details/:id/print',
		Component: BordereauxPDF,
		canDoes: ['get_client_dispatch_note_by_id'],
		premium: true,
	},
	{
		path: '/ventes/bordereaux/creation',
		Component: BordereauxCreation,
		canDoes: ['add_client_dispatch_notes'],
		premium: true,
	},
	{
		path: '/ventes/bordereaux/delivery-validation/:id',
		Component: DeliveryValidation,
		canDoes: ['add_client_dispatch_notes'],
		premium: true,
	},
	{
		path: '/ventes/bordereaux/details/:id/payments',
		Component: GroupedPayments,
		canDoes: ['get_client_dispatch_note_by_id'],
		premium: true,
	},
	// {/* ---Bordereaux Check */}
	{
		path: '/ventes/bordereaux-cheque',
		Component: BordereauxCheck,
		canDoes: ['get_all_deposit_slips'],
		premium: true,
	},
	{
		path: '/ventes/bordereaux-cheque/details/:id',
		Component: BordereauxCheckDetails,
		canDoes: ['get_deposit_slip_by_id'],
		premium: true,
	},
	{
		path: '/ventes/bordereaux-cheque/creation',
		Component: BordereauxCheckCreation,
		canDoes: ['add_deposit_slip'],
		premium: true,
	},
	// {/* ---Avoirs client */}
	{
		path: '/ventes/avoirs-client',
		Component: AvoirsClient,
		canDoes: ['get_all_client_issued_return'],
		premium: true,
	},
	{
		path: '/ventes/avoirs-client/details/:id',
		Component: AvoirsClientDetails,
		canDoes: ['get_single_client_issued_return'],
		premium: true,
	},
	{
		path: '/ventes/avoirs-client/creation',
		Component: AvoirsClientAddOrUpdate,
		canDoes: ['add_client_issued_return'],
		premium: true,
	},
	{
		path: '/ventes/avoirs-client/creation/:id',
		Component: AvoirsClientAddOrUpdate,
		canDoes: ['get_single_client_issued_return', 'edit_client_issued_return'],
		premium: true,
	},
	//{/* cars */}
	{
		path: '/parc-auto',
		Component: Cars,
		canDoes: ['get_vehicles'],
		premium: true,
	},
	{
		path: '/parc-auto/details/:id',
		Component: CarDetails,
		canDoes: ['get_single_vehicle'],
		premium: true,
	},
	{
		path: '/parc-auto/creation',
		Component: CarCreation,
		canDoes: ['add_vehicle'],
		premium: true,
	},
	{
		path: '/parc-auto/creation/:id',
		Component: CarCreation,
		canDoes: ['edit_vehicle_info'],
		premium: true,
	},
	//  {/* logs */}
	{
		path: '/logs-erreurs',
		Component: LogErrors,
		canDoes: ['get_all_log'],
	},
	{
		path: '/logs-erreurs/:id',
		Component: LogErrorsDetail,
		canDoes: ['get_log_by_id'],
	},
	//  {/* "transferts-entrepot */}
	{
		path: '/transferts-entrepot',
		Component: TransfertsEntrepot,
		canDoes: ['get_all_stock_transfers'],
		premium: true,
	},
	{
		path: '/transferts-entrepot/creation',
		Component: TransfertCreation,
		canDoes: ['post_stock_transfers', 'get_sobrus_products'],
		premium: true,
	},
	{
		path: '/transferts-entrepot/creation/:id',
		Component: TransfertCreation,
		canDoes: ['get_by_id_stock_transfers', 'edit_stock_transfers', 'get_sobrus_products'],
		premium: true,
	},
	{
		path: '/transferts-entrepot/details/:id',
		Component: TransfertsEntrepotDetails,
		canDoes: ['get_by_id_stock_transfers'],
		premium: true,
	},
	{
		path: '/inventaires',
		Component: Inventaires,
		canDoes: ['get_inventories_list'],
		premium: true,
	},
	{
		path: '/inventaires/creation',
		Component: InventaireAddOrUpdate,
		canDoes: ['add_inventories'],
		premium: true,
	},
	{
		path: '/inventaires/creation/:id',
		Component: InventaireAddOrUpdate,
		canDoes: ['get_single_inventory', 'update_inventories'],
		premium: true,
	},
	{
		path: '/inventaires/details/:id',
		Component: InventaireDetails,
		canDoes: ['get_single_inventory'],
		premium: true,
	},
	//  {/* stock */}
	{
		path: '/stock',
		Component: Stock,
		canDoes: ['get_stocks'],
		premium: true,
	},
	{
		path: '/stock/import-history',
		Component: StockImportsHistory,
		canDoes: ['get_stocks'],
		premium: true,
	},
	{
		path: '/stock/import',
		Component: StockImport,
		canDoes: ['get_stocks'],
		premium: true,
	},
	{
		path: '/stock/import/details/:id',
		Component: StockImportDetails,
		canDoes: ['get_imported_stocks_history_details'],
		premium: true,
	},
	// {/* ---Demandes */}
	{
		path: '/requests',
		Component: Requests,
		canDoes: ['get_all_demands'],
		premium: true,
	},
	{
		path: '/requests/details/:id',
		Component: RequestDetails,
		canDoes: ['get_demand_by_id'],
		premium: true,
	},
	{
		path: '/requests/addOrUpdate',
		Component: RequestAddOrUpdate,
		canDoes: ['add_demand'],
		premium: true,
	},
	{
		path: '/requests/addOrUpdate/:id',
		Component: RequestAddOrUpdate,
		canDoes: ['get_demand_by_id', 'update_demand'],
		premium: true,
	},
	// {/* ---Loyalty programes */}
	{
		path: '/loyalty-programs',
		Component: LoyaltyPrograms,
		canDoes: ['get_list_of_loyalty_programs_with_filters_and_pagination'],
		premium: true,
	},
	{
		path: '/loyalty-programs/create',
		Component: LoyaltyProgramsCreation,
		canDoes: ['add_new_loyalty_program'],
		premium: true,
	},
	{
		path: '/loyalty-programs/create/:id',
		Component: LoyaltyProgramsCreation,
		canDoes: ['update_loyalty_program'],
		premium: true,
	},
	{
		path: '/loyalty-programs/details/:id',
		Component: LoyaltyProgramsDetails,
		canDoes: ['get_one_loyalty_program_details'],
		premium: true,
	},
	// {/* rapports */}
	{
		path: '/reports',
		Component: Rapport,
	},
	{
		path: '/reports/ventes',
		Component: Ventes,
		canDoes: ['get_sales_reports'],
		premium: true,
	},
	{
		path: '/reports/reedited-bls',
		Component: ReeditedBLs,
		canDoes: ['get_reedited_client_delivery_notes_report'],
		premium: true,
	},
	{
		path: '/reports/out-of-stock-sales',
		Component: OutOfStockSales,
		canDoes: ['get_sales_reports'],
		premium: true,
	},
	{
		path: '/reports/products-table',
		Component: ProductsTable,
		canDoes: ['get_products_schedules_sales_kpi'],
		premium: true,
	},
	{
		path: '/reports/payments-report',
		Component: PaymentsReport,
		canDoes: ['get_sales_reports'],
		premium: true,
	},
	{
		path: '/reports/cash-register-closing',
		Component: CashRegister,
		canDoes: ['get_products_schedules_sales_kpi'],
		premium: true,
	},
	{
		path: '/reports/achats',
		Component: Achat,
		canDoes: ['get_purchases_reports'],
		premium: true,
	},
	{
		path: '/reports/produit',
		Component: Produit,
		canDoes: ['get_product_transactions_report'],
		premium: true,
	},
	{
		path: '/reports/product-mouvements',
		Component: ProductMouvements,
		canDoes: ['get_product_transactions'],
		premium: true,
	},
	{
		path: '/reports/missing-products',
		Component: MissingProducts,
		canDoes: ['get_missing_products'],
		premium: true,
	},
	{
		path: '/reports/quoted-products',
		Component: QuotedProducts,
		canDoes: ['get_quotas_kpi'],
	},
	{
		path: '/reports/dormant-products',
		Component: DormantProducts,
		canDoes: ['get_inactive_products'],
		premium: true,
	},
	{
		path: '/reports/stock',
		Component: StockReport,
		canDoes: ['get_clients_reports'],
		premium: true,
	},
	{
		path: '/reports/clients',
		Component: Client,
		canDoes: ['get_clients_reports'],
		premium: true,
	},
	{
		path: '/reports/client-payments',
		Component: ClientPayments,
		canDoes: ['get_client_payments_reports'],
		premium: true,
	},
	{
		path: '/reports/cel',
		Component: ChiffreAffaires,
		canDoes: ['get_turnovers_online_order_reports_by_status'],
	},
	{
		path: '/reports/chiffre-affaires',
		Component: ChiffreAffaires,
		canDoes: ['get_turnovers_online_order_reports_by_status'],
	},
	{
		path: '/reports/chiffre-affaires-client',
		Component: ChiffreAffairesClient,
		canDoes: ['get_turnovers_online_order_reports_by_client'],
	},
	{
		path: '/reports/rapport-sur-produit',
		Component: RapportSurProduit,
		canDoes: ['get_turnovers_online_order_reports_by_product'],
		premium: false,
	},
	{
		path: '/reports/marketplace',
		Component: MarketplaceReport,
		canDoes: ['get_marketplace_report'],
		premium: true,
	},
	{
		path: '/reports/sell-out',
		Component: SellOutReport,
		canDoes: ['get_marketplace_report'],
		premium: true,
	},
	{
		path: '/reports/shortage-report',
		Component: ShortageReport,
		canDoes: ['get_marketplace_report'],
		premium: true,
	},
	{
		path: '/reports/rapport-publication',
		Component: PublicationsReport,
		canDoes: ['get_marketplace_report'],
		premium: true,
	},
	{
		path: '/reports/logs-erreurs',
		Component: LogErrors,
		canDoes: ['get_online_order_errors_report'],
	},
	{
		path: '/reports/pertes-et-manque',
		Component: PertesEtManque,
		canDoes: ['get_online_order_product_quatities_gap_report'],
	},
	{
		path: '/reports/exchanges',
		Component: Exchanges,
		canDoes: ['get_products_exchanges'],
	},
	{
		path: '/reports/billing',
		Component: BillingReport,
		canDoes: ['get_sales_bills_kpi'],
	},
	{
		path: '/reports/avoirs',
		Component: AvoirsReport,
		canDoes: [''],
	},
	{
		path: '/reports/performance',
		Component: OperationalExcellence,
		canDoes: [''],
	},
	{
		path: '/settings/remises/active',
		Component: DiscountsUpdate,
		canDoes: ['get_all_methods', 'get_single_role_by_id', 'add_role_methods'],
	},
	// {/* ---Quotations */}
	{
		path: '/ventes/quotation',
		Component: Quotation,
		canDoes: ['app_client_pricingget_client_pricing_list'],
		premium: true,
	},
	{
		path: '/ventes/quotation/creation',
		Component: QuotationCreation,
		canDoes: ['app_client_pricingadd_client_pricing'],
		premium: true,
	},
	{
		path: '/ventes/quotation/creation/:id',
		Component: QuotationCreation,
		canDoes: ['app_client_pricingupdate_client_pricing'],
		premium: true,
	},
	{
		path: '/ventes/quotation/details/:id',
		Component: QuotationDetails,
		canDoes: ['app_client_pricingget_client_pricing_by_id'],
		premium: true,
	},
	// Colleagues
	// todo: add ACL TO COLLEAGUES
	{
		path: '/exchanges/colleagues',
		Component: Colleagues,
		permuim: true,
		canDoes: ['get_colleagues'],
	},
	{
		path: '/exchanges/colleagues/creation',
		Component: ColleaguesCreation,
		permuim: true,
		canDoes: ['add_colleagues', 'get_colleagues_details'],
	},
	{
		path: '/exchanges/colleagues/:id',
		Component: ColleaguesDetails,
		permuim: true,
		canDoes: ['get_colleagues_details'],
	},
	{
		path: '/exchanges/colleagues-purchases',
		Component: ColleaguesPurchases,
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-purchases/:id',
		Component: ColleaguesPurchasesDetails,
		canDoes: ['get_single_colleague_purchase'],
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-purchases/creation',
		Component: ColleaguesPurchaseCreation,
		canDoes: ['get_single_colleague_purchase', 'add_colleagues_purchases'],
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-purchases/creation/:id',
		Component: ColleaguesPurchaseCreation,
		canDoes: ['get_single_colleague_sale'],
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-sales',
		Component: ColleaguesSales,
		canDoes: ['get_colleagues_sales'],
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-sales/:id',
		Component: ColleaguesSalesDetails,
		canDoes: ['get_single_colleague_sale'],
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-sales/creation',
		Component: ColleaguesSalesCreation,
		canDoes: ['get_single_colleague_sale', 'add_colleagues_sales'],
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-sales/creation/:id',
		Component: ColleaguesSalesCreation,
		canDoes: ['edit_colleagues_sales'],
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-receipts/:id',
		Component: ColleaguesReceiptDetails,
		canDoes: ['get_colleague_incoming_payment_detail'],
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-receipts/:id/creation',
		Component: ColleaguesReceiptCreation,
		canDoes: ['add_colleague_incoming_payment'],
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-outflow/:id',
		Component: ColleaguesOutflowDetails,
		canDoes: ['add_colleague_outgoing_payment'],
		premuim: true,
	},
	{
		path: '/exchanges/colleagues-outflow/:id/creation',
		Component: ColleaguesOutflowCreation,
		canDoes: ['get_colleague_outgoing_payment_detail'],
		premuim: true,
	},
	{
		path: '/settings',
		Component: Settings,
	},
	{
		path: '/marketing/campaigns',
		Component: Publications,
		canDoes: ['list_publications'],
	},
	{
		path: '/marketing/campaigns/archived',
		Component: ArchivedPublications,
		canDoes: ['list_publications'],
	},
	{
		path: '/marketing/campaigns/create',
		Component: PublicationCreation,
		canDoes: ['add_publication'],
	},
	{
		path: '/marketing/campaigns/create/:id',
		Component: PublicationCreation,
		canDoes: ['update_publication'],
	},
	{
		path: '/marketing/campaigns/details/:id',
		Component: PublicationDetails,
		canDoes: ['list_publications'],
	},
	{
		path: '/marketing/labo-space',
		Component: LaboSpaceDetails,
	},
	{
		path: '/marketing/labo-space/products',
		Component: LaboProducts,
	},
	{
		path: '/marketing/labo-space/events',
		Component: LaboEvents,
	},
	{
		path: '/marketing/labo-space/educational-hub',
		Component: LaboEducationalHub,
	},
	{
		path: '/espace-events',
		Component: EspaceEvents,
	},
	{
		path: '/espace-events/archived',
		Component: EspaceEventsArchived,
	},
	{
		path: '/espace-events/create',
		Component: EspaceEventsCreate,
	},
	{
		path: '/espace-events/create/:id',
		Component: EspaceEventsCreate,
	},
	{
		path: '/espace-events/details/:id',
		Component: EspaceEventsDetails,
	},
];
